import Component from "@ember/component";
export default Component.extend({
  classNames: ["top-sub-section"],
});
